export const degreesToRadians = degrees => ((Number(degrees) - 90) * Math.PI) / 180.0
export const polarToCartesian = ({ center, radius, angleDegrees }) => {
  const radians = degreesToRadians(angleDegrees)

  return {
    x: Number(center.x) + Number(radius) * Math.cos(radians),
    y: Number(center.y) + Number(radius) * Math.sin(radians),
  }
}

const preReleaseModifiers = {
  default: 8,
  alpha: 6,
  beta: 4,
  rc: 2,
}
export const semverToNumber = (versionString = '0.0.0') => {
  let preReleaseModifier
  let preReleaseResult
  const [main, preReleaseRaw] = versionString.split(/[-+]/g)
  const whichPre = String(preReleaseRaw).match(/([a-z]+)/i)?.[1]
  const preRelease = preReleaseRaw && (Number(preReleaseRaw.replace(/\D+/g, '')) || 0)
  if (preRelease) {
    preReleaseModifier = preReleaseModifiers[whichPre] ?? preReleaseModifiers.default
    preReleaseResult = (preRelease * (10 ** -preReleaseModifier))
    if (preReleaseResult) {
      preReleaseResult = Number(preReleaseResult.toFixed(preReleaseModifier))
    }
  }
  const parts = String(main).split(/\D/g)
  const mainResult = Math.round(parts.map((part, index) => {
    const num = Number(part.replace(/\D/g, '')) || 0
    return (num * (10 ** -(index * 3)))
  }).reduce((acc, n) => acc + n) * (10 ** 9))
  return preRelease != null
    ? mainResult + preReleaseResult
    : mainResult
}
